export var COMMON_PROPS = ['crossOrigin', 'decoding', 'draggable', 'loading', 'referrerPolicy', 'sizes', 'srcSet', 'useMap', 'alt'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-image/es/common.js
// module id = 1125
// module chunks = 0